// Location id → display label (mirrors apps/api/prisma/seed.ts). Used for nav
// and order labels without a per-chef locations endpoint.
export const KNOWN_LOCATIONS: Record<string, string> = {
  '44444444-4444-4444-8444-444444444444': 'Downtown',
  '55555555-5555-4555-8555-555555555555': 'Uptown',
  '66666666-6666-4666-8666-666666666666': 'Harbour',
  '77777777-7777-4777-8777-777777777777': 'Riverside',
  '88888888-8888-4888-8888-888888888888': 'Westside',
  '99999999-9999-4999-8999-999999999999': 'East End',
  'aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa': 'Gallery',
};

export function locationLabel(id: string | null | undefined): string {
  if (!id) return '—';
  return KNOWN_LOCATIONS[id] ?? id.slice(0, 8);
}
